import { render, staticRenderFns } from "./ElTableWrapColumn.vue?vue&type=template&id=42a78dea&"
import script from "./ElTableWrapColumn.vue?vue&type=script&lang=js&"
export * from "./ElTableWrapColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports